import { Redirect } from 'react-router-dom';
import { NOT_FOUND } from './routeTemplates';

import ProvidersLineAsync from '../components/ProvidersLine/ProvidersLineAsync';
import ProvidersLineAsyncSCCOM from '../AppSCCOM/components/ProvidersLine/ProvidersLineAsync';

import HeaderAsync from '../components/Header/HeaderAsync';
import HeaderAsyncSCCOM from '../AppSCCOM/components/Header/HeaderAsync';

import BurgerIconAsync from '../components/Button/BurgerIcon/BurgerIconAsync';
import BurgerIconAsyncSCCOM from '../AppSCCOM/components/Button/BurgerIcon/BurgerIconAsync';

import GameCardAsync from '../components/GameCard/GameCardBaseAsync';
import GameCardSCCOM from '../AppSCCOM/components/GameCard/GameCardAsync';

import GameLaunchHeaderAsync from '../components/GameLaunch/GameLaunchHeaderDesktop/GameLaunchHeaderAsync';
import GameLaunchHeaderMobileAsync from '../components/GameLaunch/GameLaunchHeaderMobile/GameLaunchHeaderMobileAsync';

import GameLaunchHeaderAsyncSCCOM from '../AppSCCOM/components/GameLaunch/GameLaunchHeader/GameLaunchHeaderAsync';
import GameLaunchHeaderMobileAsyncSCCOM from '../AppSCCOM/components/GameLaunch/GameLaunchHeaderMobile/GameLaunchHeaderMobileAsync';

import Dashboard from '../pages/Dashboard/DashboardAsync';
import DashboardSCCOM from '../AppSCCOM/pages/Dashboard/DashboardAsync';

import NoContentAsync from '../components/NoContent/NoContentAsync';
import NoContentAsyncSCCOM from '../AppSCCOM/components/NoContent/NoContentAsync';

import ErrorPageAsync from '../pages/ErrorPage/ErrorPageAsync';
import ErrorPageAsyncSCCOM from '../AppSCCOM/pages/ErrorPage/ErrorPageAsync';

import BaseLayoutAsync from '../layouts/BaseLayout/BaseLayoutAsync';
import BaseLayoutAsyncSCCOM from '../AppSCCOM/layouts/BaseLayout/BaseLayoutAsync';

import RecentGamesAsyncSCCOM from '../AppSCCOM/pages/RecentGames/RecentGamesAsync';
import GameCardsWidgetRecentLaunchedSCCOM from '../AppSCCOM/components/GameCardsWidget/GameCardsWidgetRecentLaunched/GameCardsWidgetRecentLaunched';
import GameCardsLineRecentLaunched from '../components/GameCardsLine/GameCardsLineRecentLaunched/GameCardsLineRecentLaunched';

import SearchPageAsync from '../pages/SearchPage/SearchPageAsync';
import SearchPageAsyncSCCOM from '../AppSCCOM/pages/SearchPage/SearchPageAsync';

import Heading from '../components/Heading/Heading';
import HeadingSCCOM from '../AppSCCOM/components/Heading/Heading';

import GameCardsLineProvider from '../components/GameCardsLine/GameCardsLineProvider/GameCardsLineProvider';
import GameCardsWidgetProviderSCCOM from '../AppSCCOM/components/GameCardsWidget/GameCardsWidgetProvider/GameCardsWidgetProvider';

import SeoPageHeading from '../AppSCCOM/components/SEOWrapper/SeoPageHeading';

import { SCCOM_BRAND } from './noNameBrands';

export const GAME_HEADER_LIST = {
  [SCCOM_BRAND]: GameLaunchHeaderAsyncSCCOM,
  default: GameLaunchHeaderAsync,
};

export const GAME_HEADER_MOBILE_LIST = {
  [SCCOM_BRAND]: GameLaunchHeaderMobileAsyncSCCOM,
  default: GameLaunchHeaderMobileAsync,
};

export const HEADER_BRAND_CONFIG = {
  [SCCOM_BRAND]: HeaderAsyncSCCOM,
  default: HeaderAsync,
};

export const BURGER_ICON_BRAND_CONFIG = {
  [SCCOM_BRAND]: BurgerIconAsyncSCCOM,
  default: BurgerIconAsync,
};

export const GAME_CARD_BRAND_CONFIG = {
  [SCCOM_BRAND]: GameCardSCCOM,
  default: GameCardAsync,
};

export const PROVIDERS_LINE_LIST = {
  [SCCOM_BRAND]: ProvidersLineAsyncSCCOM,
  default: ProvidersLineAsync,
};

export const DASHBOARD_LIST = {
  [SCCOM_BRAND]: DashboardSCCOM,
  default: Dashboard,
};

export const NO_CONTENT_WIDGET_COLLECTION = {
  [SCCOM_BRAND]: NoContentAsyncSCCOM,
  default: NoContentAsync,
};

export const ERROR_PAGE_LIST = {
  [SCCOM_BRAND]: ErrorPageAsyncSCCOM,
  default: ErrorPageAsync,
};

export const BASE_LAYOUT_LIST = {
  [SCCOM_BRAND]: BaseLayoutAsyncSCCOM,
  default: BaseLayoutAsync,
};

export const RECENT_GAMES_LIST = {
  [SCCOM_BRAND]: RecentGamesAsyncSCCOM,
  default: () => <Redirect to={NOT_FOUND} />,
};

export const RECENT_GAMES_CARDS_WIDGET = {
  [SCCOM_BRAND]: GameCardsWidgetRecentLaunchedSCCOM,
  default: GameCardsLineRecentLaunched,
};

export const SEARCH_PAGE = {
  [SCCOM_BRAND]: SearchPageAsyncSCCOM,
  default: SearchPageAsync,
};

export const HEADING_COMPONENT_COLLECTION = {
  [SCCOM_BRAND]: HeadingSCCOM,
  default: Heading,
};

export const GAME_CARDS_PROVIDER = {
  [SCCOM_BRAND]: GameCardsWidgetProviderSCCOM,
  default: GameCardsLineProvider,
};

export const PAGE_TITLE_HEADING = {
  [SCCOM_BRAND]: SeoPageHeading,
  default: 'h1',
};
